import { css, cx } from '@emotion/css';
import { Typography } from 'antd';
import type React from 'react';
import { monoFont } from '../styles/globalCss.ts';

const containerClassName = css`
  display: flex;
`;

const swatchClassName = (color: string) => css`
  width: 16px;
  height: 16px;
  background-color: ${color};
  border-radius: 999px;
`;

const labelClassName = cx(
  monoFont,
  css`
    font-size: 0.9em;
    margin-left: 5px;
  `
);

export interface ColorInfoProps {
  color: string;
}

// Swatch + hex value. The hex is a code → monospace (see .claude/rules/numeric-typography.md).
export const ColorInfo: React.FC<ColorInfoProps> = ({ color }) => {
  return (
    <div className={containerClassName}>
      <div className={swatchClassName(color)} />
      <Typography.Text type="secondary" className={labelClassName}>
        {color}
      </Typography.Text>
    </div>
  );
};
